import { render, staticRenderFns } from "./form-number-stepper.generic.vue?vue&type=template&id=45d589ba&"
import script from "./form-number-stepper.generic.vue?vue&type=script&lang=js&"
export * from "./form-number-stepper.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports